import { useAppDispatch } from '../../hooks/redux';
import { OverlayType } from '../interface';
import { toolbarAndNavDisplayConfig } from '../actions';
import { useEffect, useMemo } from 'react';
import { useOverlayDisplayLogic } from './useOverlayDisplayLogic';
const ovarlayClassesToObserve = new Set(['uiFullScreenBackground', 'space-sword--editor']);
export function handleOverlayMutation(mutations) {
  let overlayState;
  for (const m of mutations) {
    if (!isTrueClassMutation(m)) {
      continue;
    }
    if (currentMutationHasRelevantClass(m) && isOverlayAdded(m)) {
      overlayState = {
        isOverlayOpen: true,
        overlayType: OverlayType.MODAL
      };
      break;
    }
    if (isOverlayRemoved(m)) {
      overlayState = {
        isOverlayOpen: false,
        overlayType: OverlayType.MODAL
      };
      break;
    }
  }
  return overlayState;
  function isTrueClassMutation(mr) {
    const targetElement = mr.target;
    const currClassAttrVal = Array.from(targetElement.classList).join(' ');
    return mr.oldValue !== currClassAttrVal;
  }
  function isOverlayAdded(m) {
    const bodyEl = m.target;
    if (bodyEl.classList.contains('space-sword--editor')) {
      return true;
    }
    const modalOverlayEl = getModalOverlayEl(bodyEl);
    if (modalOverlayEl) {
      return !!isOverlayDialogFullscreen(modalOverlayEl);
    }
    return false;
  }
  function isOverlayRemoved(m) {
    return !currentMutationHasRelevantClass(m) && prevMutationHasRelevantClass(m);
  }
  function currentMutationHasRelevantClass(mr) {
    const classList = Array.from(mr.target.classList);
    return classList.some(cssClass => ovarlayClassesToObserve.has(cssClass));
  }
  function prevMutationHasRelevantClass(mr) {
    const oldValueStr = mr.oldValue || '';
    for (const cssClass of Array.from(ovarlayClassesToObserve)) {
      if (oldValueStr.includes(cssClass)) {
        return true;
      }
    }
    return false;
  }
  function getModalOverlayEl(targetEl) {
    if (targetEl) {
      return targetEl.querySelector(`[data-layer-for="${OverlayType.MODAL}"]`);
    }
    return null;
  }
  function isOverlayDialogFullscreen(overlayEl) {
    const dialogEl = overlayEl.querySelector(`.uiDialog-root`);
    // eslint-disable-next-line hubspot-dev/no-private-classes
    const fullscreenDialogClass = 'private-modal--fullscreen';
    return dialogEl && dialogEl.classList.contains(fullscreenDialogClass);
  }
}
export function useObserveOverlayChanges() {
  const dispatch = useAppDispatch();
  const modalOverlayMo = useMemo(() => new MutationObserver(mutations => {
    const overlayState = handleOverlayMutation(mutations);
    if (overlayState) {
      dispatch(toolbarAndNavDisplayConfig(overlayState));
    }
  }), [dispatch]);
  const {
    isOverlayConfigStateInit,
    isTopLevelWindow
  } = useOverlayDisplayLogic();
  useEffect(() => {
    if (isOverlayConfigStateInit && isTopLevelWindow) {
      const htmlElements = document.getElementsByTagName('body');
      if (htmlElements.length) {
        // Timeout to give DOM some breathing space before we start observing
        const timeoutId = setTimeout(() => {
          modalOverlayMo.observe(htmlElements[0], {
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true
          });
          clearTimeout(timeoutId);
        }, 100);
      }
    }
    return () => modalOverlayMo.disconnect();
  }, [dispatch, isOverlayConfigStateInit, isTopLevelWindow, modalOverlayMo]);
}